import LocalizationStore from '../Stores/LocalizationStore'
import { AjvError, FormValidation } from 'react-jsonschema-form'
import { User, UserRoles } from '../Model/User'
import EnumHelpers from '../Helpers/EnumHelpers'

const ls = LocalizationStore.getInstance()

export function getUserCreateFormSchema(): any {
    let roles = EnumHelpers.keys(UserRoles)
        .filter(x => x !== UserRoles.SuperAdmin)
        
    return {
        'title': ls.t!('User'),
        'type': 'object',
        'required': [
            'userName',
            'email',
            'roles'
        ],
        'properties': {
            'userName': {
                'title': ls.t!('userName'),
                'type': 'string'
            },
            'email': {
                'title': ls.t!('email'),
                'type': 'string',
                'format': 'email'
            },
            'roles': {
                'title': ls.t!('roles'),
                'type': 'array',
                'items': {
                    'type': 'string',
                    'enum': roles,
                    'enumNames': roles.map(x => ls.t(x))
                },
                'minItems': 1,
                'uniqueItems': true
            },
            'password': {
                'title': ls.t!('Password'),
                'type': 'string'
            },
            'confirmPassword': {
                'title': ls.t!('Password'),
                'type': 'string'
            }
        }
    }
}

export function getUserEditFormSchema(): any {
    let roles = EnumHelpers.keys(UserRoles)
        .filter(x => x !== UserRoles.SuperAdmin)

    return {
        'title': ls.t!('User'),
        'type': 'object',
        'required': [
            'name',
            'email',
            'roles'
        ],
        'properties': {
            'id': {
                'title': ls.t!('id'),
                'type': 'string'
            },
            'name': {
                'title': ls.t!('userName'),
                'type': 'string'
            },
            'email': {
                'title': ls.t!('email'),
                'type': 'string',
                'format': 'email'
            },
            'roles': {
                'title': ls.t!('roles'),
                'type': 'array',
                'items': {
                    'type': 'string',
                    'enum': roles,
                    'enumNames': roles.map(x => ls.t(x))
                },
                'minItems': 1,
                'uniqueItems': true
            },
            'registrationDateTime': {
                'title': ls.t!('registrationDateTime'),
                'type': 'string'
            },
            'lastLoginDateTime': {
                'title': ls.t!('lastLoginDateTime'),
                'type': 'string'
            },
            'activeDateTime': {
                'title': ls.t!('activeDateTime'),
                'type': 'string'
            },
            'isActive': {
                'type': 'boolean',
                'title': ls.t!('isActive'),
            },
            'password': {
                'title': ls.t!('Password'),
                'type': 'string'
            },
            'confirmPassword': {
                'title': ls.t!('Password'),
                'type': 'string'
            }
        }
    }
}

export const uiUserCreateFormSchema = {
    'id': {
        'ui:readonly': true,
        'ui:widget': 'hidden'
    },
    'activeDateTime': {
        'ui:widget': 'hidden'
    },
    'lastLoginDateTime': {
        'ui:widget': 'hidden'
    },
    'name': {
        'ui:autofocus': true
    },
    'email': {
    },
    'roles': {
        'ui:widget': 'checkboxes'
    },
    'password': {
        'ui:widget': 'hidden'
    },
    'confirmPassword': {
        'ui:widget': 'hidden'
    },
    'isActive': {
        'ui:widget': 'hidden'
    }
}

export const uiUserEditFormSchema = {
    'id': {
        'ui:readonly': true,
    },
    'activeDateTime': {
        'ui:readonly': true,
    },
    'lastLoginDateTime': {
        'ui:readonly': true,
    },
    'registrationDateTime': {
        'ui:readonly': true,
    },
    'name': {
        'ui:autofocus': true
    },
    'email': {
    },
    'roles': {
        'ui:widget': 'checkboxes'
    },
    'password': {
        'ui:widget': 'hidden'
    },
    'confirmPassword': {
        'ui:widget': 'hidden'
    },
    'isActive': {
        'ui:widget': 'hidden'
    }
}

export const uiUserSelfEditFormSchema = {
    'id': {
        'ui:readonly': true,
    },
    'activeDateTime': {
        'ui:readonly': true,
    },
    'lastLoginDateTime': {
        'ui:readonly': true,
    },
    'name': {
        'ui:autofocus': true
    },
    'email': {
    },
    'roles': {
        'ui:readonly': 'true'
    },
    'password': {
        'ui:widget': 'hidden'
    },
    'confirmPassword': {
        'ui:widget': 'hidden'
    },
    'isActive': {
        'ui:widget': 'hidden'
    }
}

export const uiUserReadonlyFormSchema = {
    'id': {
        'ui:readonly': true,
    },
    'activeDateTime': {
        'ui:readonly': true,
    },
    'lastLoginDateTime': {
        'ui:readonly': true,
    },
    'name': {
        'ui:readonly': true,
    },
    'email': {
        'ui:readonly': true
    },
    'roles': {
        'ui:readonly': 'true'
    },
    'password': {
        'ui:widget': 'hidden'
    },
    'confirmPassword': {
        'ui:widget': 'hidden'
    },
    'registrationDateTime': {
        'ui:readonly': true,
    },
    'isActive': {
        'ui:widget': 'hidden'
    }
}

export function transformErrors(errors: Array<AjvError>) {
    return errors.map((error: AjvError) => {
        if ('.roles' === error['property'] && error['params']['limit']) {
            error['message'] = ls.t('roles should NOT have less than 1')
        }
        return error
    })
}

export function validate(formData: User, errors: FormValidation) {
    // if (!formData.user.email) {
    //     errors.user['email'].addError(ls.t('Invalid email'))
    // }
    return errors
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Model/UserEditForm.tsx